import {
  APIPersonalAutoApplicationFormDriver,
  APIBinderData,
  APIInsuranceClaim,
  APIInsuranceClaimType,
  APIInsuranceRecord,
} from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { formatFault, formatPayout, processValidation } from '../utils/helpers';

export const processUnknownOperatorClaimsData = (
  binderReportData: APIBinderData,
  validation?: Validation,
): BinderSectionData => {
  const autoPlusDataArray = binderReportData.insurance_data?.data || [];
  const drivers = binderReportData.application_data?.drivers || [];

  const driverClaimsData = drivers.map(
    (driver: APIPersonalAutoApplicationFormDriver, index: number) => {
      const autoplusClaims: APIInsuranceClaim[] = [];

      autoPlusDataArray.forEach((autoPlusData: APIInsuranceRecord) => {
        const claims =
          autoPlusData?.claims?.filter((claim: APIInsuranceClaim) => {
            return claim.driver['1st'] === 'unknown';
          }) || [];

        // Add the filtered claims from this AutoPlus record to the overall array
        autoplusClaims.push(...claims);
      });

      // Process AutoPlus Claims
      const processedAutoplusClaims = autoplusClaims.map(
        (claim: APIInsuranceClaim) => ({
          date: claim?.loss_date || '',
          driver:
            claim?.driver?.['1st'] || driver?.name || `Driver ${index + 1}`,
          type:
            claim?.types
              ?.map((t: APIInsuranceClaimType) => {
                // Handle the actual structure: code_type, loss, paid
                if (t.code_type) {
                  return t.code_type;
                }
                return t;
              })
              .join(', ') || 'Unknown',
          fault: formatFault(claim?.driver?.fault),
          payout: formatPayout(claim?.expenses_on_the_claim),
          vehicle: claim?.vehicle || 'Unknown Vehicle',
          source: claim?.source || 'Unknown',
        }),
      );

      const finalAutoplusClaims = processedAutoplusClaims;

      return {
        driverName: driver?.name || `Driver ${index + 1}`,
        claims: finalAutoplusClaims,
      };
    },
  );

  const validationData = processValidation(validation);

  return {
    title: 'Unknown Operator Claims',
    description: '',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      drivers: driverClaimsData,
    },
  };
};
